<script context="module" lang="ts">
    const scroll = {} as Record<string, number | undefined>;
</script>

<script lang="ts">
    import { onMount, getContext } from "svelte";
    import LayoutComp from "./layout/LayoutComp.svelte";

    import type { Setting, SettingsPage } from ".";
    import type { ValueWritable } from "..";

    const search = getContext("search") as ValueWritable<string>;

    let pageElement: HTMLDivElement;

    export let page: SettingsPage;
    export let settings: Setting[];

    onMount(() => {
        pageElement.scrollTop = scroll[page.id] ?? 0;
        return () => {
            scroll[page.id] = pageElement.scrollTop;
        };
    });

</script>

<!----------------------------------------------------------------------------->

<div class="page" class:templated={!page.template} bind:this={pageElement} class:filter={!page.template && $search}>
  {#if page.template}
    <svelte:component this={page.template.component} layout={page.layout} {settings}
                      {...page.template.props ?? {}} />
  {:else}
    <div class="settings">
      {#each page.layout as layout}
        <LayoutComp layout={layout} settings={settings} />
      {/each}
    </div>
  {/if}
</div>

<!----------------------------------------------------------------------------->

<style>
    .page {
        grid-area: page;
        height: 100%;
        min-height: 0;
    }

    .templated {
        padding-inline: 0.5rem;
        overflow-y: scroll;
        scrollbar-width: thin;
    }

    .settings {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        margin-bottom: 3em;
    }

    .filter {
        background: var(--g50);
    }

    .settings :global([data-search="included"]) {
        background: var(--g100);
        box-shadow: -3px 0 0 0 var(--gacc200);
    }

    .settings :global([data-search="excluded"]) {
        opacity: 0.5;
    }
</style>
